import React from "react";
import GoogleLoginComponent from "./GoogleLoginComponent";
import CredentialsLoginComponent from "./CredentialsLoginComponent";
import logoDocLift from "../images/logoDocLift.png";
const LoginComponent = () => {
  return (
    <div className="w-full px-4 flex items-center justify-center flex-col relative overflow-x-hidden">
      <div className="bg-white/90 backdrop-blur-xl border border-gray-200 px-10 py-12 min-h-[320px] w-full max-w-[420px] rounded-3xl shadow-2xl relative z-10 flex flex-col items-center">
        <div className="text-center flex justify-center mb-6">
          <img src={logoDocLift} className="h-[48px] object-contain drop-shadow-lg" alt="DocLift" />
        </div>

        <h2 className="text-[26px] text-gray-900 font-semibold text-center mb-2 tracking-tight">
          Welcome to DocLift
        </h2>
        <p className="text-gray-600 text-[15px] mb-8 text-center">
          Log in to your account
        </p>

        <div className="w-full">
          <CredentialsLoginComponent />
        </div>

        {/* <div className="w-full flex items-center my-6">
          <div className="flex-grow border-t border-gray-200"></div>
          <span className="px-3 text-gray-500 text-sm">Or</span>
          <div className="flex-grow border-t border-gray-200"></div>
        </div>

        <div className="w-full">
          <GoogleLoginComponent />
        </div> */}
      </div>
    </div>
  );
};

export default LoginComponent;
